import warning_icon from "../../common/assets/images/errormark.png";
const Warnings = ({warningMessage,hasPrincipalHAC}) => {
  return (
    <div>
      <div className="warning-container">
        {warningMessage && warningMessage.length > 0 && (
          <div className="code-assign-warnings">
            <img src={warning_icon} alt="warning" style={{ height: "20px" }} />
            <p>{warningMessage[0]}</p>{" "}
          </div>
        )}
        {hasPrincipalHAC && (
          <div className="code-assign-warnings">
            <img src={warning_icon} alt="warning" style={{ height: "20px" }} />
            <p>
              Warning: Invalid Principal Diagnosis/ Condition Onset Flag
              selection
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Warnings;
